import { cn } from "@/lib/utils";

// The tenant's own logo where one is uploaded; otherwise a monogram of the charity's name.
export const TenantMark = ({ logoUrl, name, monogram, size = 48, className, testId }) => {
  const initials = (monogram || derive(name)).slice(0, 3);
  return logoUrl ? (
    <span
      className={cn("grid shrink-0 place-items-center overflow-hidden rounded-xl bg-[#E2E8F0] ring-1 ring-black/5", className)}
      style={{ width: size, height: size }}
      data-testid={testId}
    >
      <img src={logoUrl} alt={name || "Tenant logo"} data-testid="tenant-mark-image"
           className="h-full w-full object-contain p-1" />
    </span>
  ) : (
    <span
      className={cn("grid shrink-0 place-items-center rounded-xl font-display font-bold tracking-tight text-white shadow-sm", className)}
      style={{
        width: size, height: size,
        fontSize: Math.max(11, Math.round(size / (initials.length > 2 ? 3.1 : 2.5))),
        background: "linear-gradient(140deg, #1E3A8A 0%, #10B981 100%)",
      }}
      data-testid={testId}
    >
      <span data-testid="tenant-mark-monogram">{initials}</span>
    </span>
  );
};

const SKIP = new Set(["the", "of", "for", "and", "a", "an", "to", "in", "on", "at", "by", "&"]);

export function derive(name) {
  const words = (name || "")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .split(/\s+/)
    .filter((w) => w && !SKIP.has(w.toLowerCase()));
  return words.slice(0, 3).map((w) => w[0].toUpperCase()).join("") || "SC";
}

export default TenantMark;
